"use client";

import React,{useId } from "react";
import Link from "next/link";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

// import required modules
import { Pagination } from "swiper/modules";
import Typography from "./Typography";

interface Hotel {
  id: number;
  name: string;
  image: string;
  address: string;
  to: string;
}

interface HotelsSliderProps {
  title: string;
  hotels: Array<Hotel>;
}

const HotelSlide = ({ hotel }: { hotel: Hotel }) => {
  return (
    <Link href={hotel.to} className="block">
      <div className="relative w-full h-60 rounded-lg overflow-hidden">
        <img
          src={hotel.image}
          alt={hotel.name}
          className="absolute block inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 h-fit m-auto mb-0 p-2">
          <div className="p-2 rounded-md bg-background">
            <Typography variant="h3" className="mb-1">{hotel.name}</Typography>
            <Typography
              variant="body2"
              className="block overflow-hidden text-ellipsis whitespace-nowrap max-w-[18rem] truncate"
            >
              {hotel.address}
            </Typography>
          </div>
        </div>
      </div>
    </Link>
  );
};

const HotelsSlider = ({ title, hotels }: HotelsSliderProps) => {
    const id = useId(); // یکتا برای هر اسلایدر

    const paginationClass = `pagination-${id}`;

    return (
        <section className="mb-7 lg:mb-10">
            <Swiper
                modules={[Pagination]}
                loop
                slidesPerView={1}
                spaceBetween={30}
                breakpoints={{
                    600: { slidesPerView: 2 },
                    900: { slidesPerView: 3 },
                    1534: { slidesPerView: 4 },
                }}
                pagination={{
                    el: `.${paginationClass}`,
                    clickable: true,
                }}
            >
                {hotels.map((hotel) => (
                    <SwiperSlide key={hotel.id}>
                        <HotelSlide hotel={hotel} />
                    </SwiperSlide>
                ))}
            </Swiper>

            <div className={`${paginationClass} mt-1 text-center`} />
        </section>
    );
};

export default HotelsSlider;
